'use client';

import type { PropsWithChildren } from 'react';
import { useLayoutEffect } from 'react';
import { useShallow } from 'zustand/react/shallow';

import { LoadingPageTemplate } from '@/components/client';
import { ROUTES } from '@/constants';
import { useCustomRouter } from '@/hooks/useCustomRouter';
import { useAuthStore } from '@/stores/AuthStore';

const PrivateAccessController = ({ children }: PropsWithChildren) => {
  const [isLogin, isDisabledAccessControl] = useAuthStore(
    useShallow((state) => [state.isLogin, state.isDisabledAccessControl]),
  );
  const router = useCustomRouter();

  useLayoutEffect(() => {
    if (isDisabledAccessControl) return;

    if (isLogin === false) {
      return router.replace(
        ROUTES.LOGIN.withSearchParams({
          searchParams: {
            redirect: location.pathname + location.search,
          },
        }),
      );
    }
  }, [isLogin, router, isDisabledAccessControl]);

  return isLogin || isDisabledAccessControl ? (
    children
  ) : (
    <LoadingPageTemplate />
  );
};

export default PrivateAccessController;
